import { A } from '@adornis/base/env-info.js';
import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';
import { Base } from '@adornis/buildify/db/Base.js';
import { BaseH3 } from '@adornis/buildify/db/extensions/text/BaseH3.js';
import { BaseText } from '@adornis/buildify/db/extensions/text/BaseText.js';
import { DubniumBaseTag } from '@adornis/digitale-helden-shared/db/buildify/DubniumBaseTag.js';
import { Link } from '@adornis/digitale-helden-shared/db/buildify/Link.js';
import { validate } from '@adornis/validation/decorators.js';
import { nonOptional } from '@adornis/validation/functions/nonOptional.js';

@Entity()
export class BaseCarousel extends Base {
  static override _class = 'BaseCarousel';

  @Field(type => Boolean) isInfinityScroll: Maybe<boolean>;
  @Field(type => [BaseCarouselItem]) items: Maybe<BaseCarouselItem[]>;
}

@Entity()
export class BaseCarouselItem extends AdornisEntity {
  static override _class = 'BaseCarouselItem';

  @validate(nonOptional())
  @Field(type => String, { default: v => v ?? A.getGloballyUniqueID() })
  _id!: string;
}

@Entity()
export class BaseCarouselItemTextUnderImage extends BaseCarouselItem {
  static override _class = 'BaseCarouselItemTextUnderImage';

  @validate(nonOptional())
  @Field(type => DubniumBaseTag)
  tag!: DubniumBaseTag;

  @validate(nonOptional())
  @Field(type => DubniumBaseTag)
  tagOnHover!: DubniumBaseTag;

  @validate(nonOptional())
  @Field(type => BaseH3)
  heading!: BaseH3;

  @validate(nonOptional())
  @Field(type => BaseText)
  text!: BaseText;

  @validate(nonOptional())
  @Field(type => String)
  imageID!: string;

  @validate(nonOptional())
  @Field(type => Link)
  link!: Link;
}

@Entity()
export class BaseCarouselItemExpandingText extends BaseCarouselItem {
  static override _class = 'BaseCarouselItemExpandingText';

  @validate(nonOptional())
  @Field(type => DubniumBaseTag)
  tag!: DubniumBaseTag;

  @validate(nonOptional())
  @Field(type => DubniumBaseTag)
  tagOnHover!: DubniumBaseTag;

  @validate(nonOptional())
  @Field(type => BaseH3)
  heading!: BaseH3;

  @validate(nonOptional())
  @Field(type => BaseText)
  smallText!: BaseText;

  @validate(nonOptional())
  @Field(type => BaseText)
  text!: BaseText;

  @validate(nonOptional())
  @Field(type => BaseText)
  textOnHover!: BaseText;

  @Field(type => String)
  imageID?: string;

  @validate(nonOptional())
  @Field(type => Link)
  link!: Link;
}
